module.exports = __webpack_public_path__ + "img/panneau.10832b29.png";